import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import CompanyAdminMasterContent from "../../components/Masters/CompanyAdminMaster/CompanyAdminMasterContent";

const CompanyAdminMaster = () => {
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <CompanyAdminMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default CompanyAdminMaster;
